import InvestmentStats from './InvestmentStats';

export default InvestmentStats;
